import axios from 'axios'
import { parseRequestError } from '@/common/utilities.ts'
import {
  DatabusInboundProcessingStatus,
  DatabusMessageDirection,
  DatabusMessageLogsResponse,
  DatabusMessageLogsResponseSchema,
  DatabusSourceSystem,
} from './schema.ts'

export type DatabusMessageLogSortBy =
  | 'id'
  | 'source_system'
  | 'entity'
  | 'entity_id'
  | 'action'
  | 'message_direction'
  | 'inbound_processing_status'
  | 'error'
  | 'processed_at'
  | 'event_emitted_at'
  | 'created_at'

export type GetDatabusMessageLogsParams = {
  page: number
  per_page: number
  search?: string
  sort_by?: DatabusMessageLogSortBy
  sort_order?: 'asc' | 'desc'
  source_system?: DatabusSourceSystem
  message_direction?: DatabusMessageDirection
  inbound_processing_status?: DatabusInboundProcessingStatus
}

export async function GETDatabusMessageLogs(
  params: GetDatabusMessageLogsParams
): Promise<DatabusMessageLogsResponse> {
  try {
    const response = await axios.get('databus_message_logs', {
      params: {
        paginate: 1,
        page: params.page,
        per_page: params.per_page,
        ...(params.search && { search: params.search }),
        ...(params.sort_by && { sort_by: params.sort_by }),
        ...(params.sort_order && { sort_order: params.sort_order }),
        ...(params.source_system && { source_system: params.source_system }),
        ...(params.message_direction && {
          message_direction: params.message_direction,
        }),
        ...(params.inbound_processing_status && {
          inbound_processing_status: params.inbound_processing_status,
        }),
      },
    })

    return DatabusMessageLogsResponseSchema.parse(response.data)
  } catch (error) {
    throw new Error(parseRequestError(error).message)
  }
}
